export const COMPANY_CLEAR_STORE = "COMPANY_CLEAR_STORE";

export const COMPANY_NEW_SAVE_START = "COMPANY_NEW_SAVE_START";
export const COMPANY_NEW_SAVE_SUCCESS = "COMPANY_NEW_SAVE_SUCCESS";
export const COMPANY_NEW_SAVE_FAIL = "COMPANY_NEW_SAVE_FAIL";

export const COMPANY_SAVE_START = "COMPANY_SAVE_START";
export const COMPANY_SAVE_SUCCESS = "COMPANY_SAVE_SUCCESS";
export const COMPANY_SAVE_FAIL = "COMPANY_SAVE_FAIL";

export const COMPANY_DETAIL_START = "COMPANY_DETAIL_START";
export const COMPANY_DETAIL_SUCCESS = "COMPANY_DETAIL_SUCCESS";
export const COMPANY_DETAIL_FAIL = "COMPANY_DETAIL_FAIL";

export const COMPANY_USER_LIST_LOAD_START = "COMPANY_USER_LIST_LOAD_START";
export const COMPANY_USER_LIST_LOAD_SUCCESS = "COMPANY_USER_LIST_LOAD_SUCCESS";
export const COMPANY_USER_LIST_LOAD_FAIL = "COMPANY_USER_LIST_LOAD_FAIL";

export const COMPANY_USER_ADD_START = "COMPANY_USER_ADD_START";
export const COMPANY_USER_ADD_SUCCESS = "COMPANY_USER_ADD_SUCCESS";
export const COMPANY_USER_ADD_FAIL = "COMPANY_USER_ADD_FAIL";
